module.exports = __webpack_public_path__ + "static/media/IMG.ab8aca2c.bmp";